export default {
  appTitle: 'Sign-up | Wirecard',
  appHeader: {
    services: 'Services',
    company: 'Company',
    resources: 'Resources'
  },
  appHead: {
    mainTitle: 'Accept credit cards now',
    subTitle: 'Get in touch with us to integrate Visa and Mastercard into your online shop',
    description: 'Please have a digital copy of your <strong>ID card</strong>, your <strong>certificate of entry in the commercial register</strong> (not for sole partnerships / freelancers) and proof of your current <strong>business address</strong>. <br>We will ask you to upload these documents during the course of your registration.'
  },
  aliasForm: {
    label: 'Please enter your first name',
    button: 'Start sign-up',
    invalid: 'Please provide a valid name.'
  },
  paymentMethods: 'Available payment methods:',
  ecommerceSystems: 'Available e-commerce systems:',
  features: {
    title: 'Fast, secure payment processing and immediate payouts',
    description: {
      p1: 'Credit cards are among the most popular payment methods in e-commerce.',
      p2: 'With Wirecard, you can easily integrate Visa and Mastercard into your shop.',
      p3: 'Oﬀer your customers convenient and secure payment and proﬁt from immediate payouts.'
    },
    feat1: 'Simple and secure payment processing for Visa and Mastercard (with 3D Secure)',
    feat2: 'Real-time account access and immediate payouts',
    feat3: 'Intuitive dashboard with integrated analysis functions',
    feat4: 'Access to additional payment methods (coming soon)',
    feat5: 'Available for Magento 2, PrestaShop and WooCommerce'
  },
  video: {
    title: 'Clear dashboard with a full range of functions',
    description: 'You can use the dashboard to manage your Wirecard account and all your transactions really easily. See all account activities at a glance and access a range of analyses and reports that will help you optimize your business. For a detailed overview of the dashboard and all its features, check out our tutorial.',
    button: 'Watch the tutorial now'
  },
  references: {
    title: 'References',
    ref1: {
      content: '“Smooth and secure payment transactions are absolutely essential for our platform. We can rely 100% on Wirecard.”',
      role: 'Founder and Director'
    },
    ref2: {
      content: '“We were looking for a solution that we could easily integrate into our shop and ﬂexibly adapt to our needs in the future.”',
      role: 'Founder and CEO'
    },
    ref3: {
      content: '“With Wirecard, we can process our customers‘ credit card payments quickly and securely. All revenue is available immediately after the pay ments have been made.”',
      role: 'Director'
    }
  },
  footer: {
    aboutTitle: 'Digitize now',
    aboutDescription: 'Wirecard is one of the world’s fastest growing digital platforms for financial commerce. We offer our customers a constantly growing ecosystem of value-added services related to digital payment transactions: online, mobile and at the point of sale.',
    aboutButton: 'Contact Us',
    follow: 'Follow Us',
    menu: {
      company: 'Company',
      benefits: 'Benefits',
      products: 'Products',
      marketing: 'Marketing Intelligence',
      investor: 'Investor Relations',
      newsroom: 'Newsroom',
      careers: 'Careers'
    },
    newsletter: {
      title: 'Subscribe now to our newsletter to keep up to date with the latest news about Wirecard innovations and the payment industry.',
      input: 'Your email address...',
      terms: 'I hereby consent to your sending me further information in accordance with the {0}. I understand that I can withdraw my consent at any time without prejudice.',
      pp: 'Privacy Policy'
    },
    labs: 'Wirecard Labs',
    subMenu: {
      legal: 'Legal Notice',
      privacy: 'Privacy Policy'
    }
  }
}
